/**
 * The deletion date outlives the reload that follows the request (FE-331):
 * the app comes back as a guest and then says when the account goes.
 */
const STORAGE_KEY = 'xyro.accountDeletionScheduledFor'

/** `scheduledFor` (ms) is null when the backend did not say. */
export const saveDeletionNotice = (scheduledFor: number | null) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, String(scheduledFor ?? 'unknown'))
  } catch {
    // NOTE: storage blocked: the reload just shows no toast
  }
}

export interface DeletionNotice {
  scheduledFor: number | null
}

/** The saved notice, handed out once; null when there is none. */
export const takeDeletionNotice = (): DeletionNotice | null => {
  try {
    const saved = sessionStorage.getItem(STORAGE_KEY)
    sessionStorage.removeItem(STORAGE_KEY)
    if (!saved) return null

    const time = Number(saved)
    return { scheduledFor: Number.isFinite(time) ? time : null }
  } catch {
    return null
  }
}
